const gql = {
  query: `mutation updateAccAddress($input: UpdateAccAddress!){
    updateAccAddress(input: $input)
}`,
  variables: {
    input: {
      address: {
        addressLines: null,
        city: null,
        state: null,
        stateCountryCode: null,
        zipCode: null,
        zipCodeSuffix: null,
      },
      addressOverrideCode: false,
      planList: [],
      residentialAddress: {
        addressLines: null,
        city: null,
        state: null,
        stateCountryCode: null,
        zipCode: null,
        zipCodeSuffix: null,
      },
      residentialOverrideCode: false,
      taGroupIds: [],
      updateStateCode: false,
    },
  },
  meta: {
    label: "Update Account Address",
  },
};

export default gql;
